export class ARAdjustmentWriteOffItemParametersDto {
    adjustmentItemId: number;
    writeOffAmount: number;
}
